import React from 'react'
import { PageSchema } from './usePageSchema'

// Legacy SubServiceSchema - now uses the universal system with breadcrumbs
const SubServiceSchema = ({ title, url, parentTitle, parentUrl, description, provider = "Ishan Tech" }) => {
    // If props are provided, use custom schema with breadcrumbs
    // if (title && url && parentTitle && parentUrl) {
    //     const serviceSchema = {
    //         "@context": "https://schema.org",
    //         "@type": "Service",
    //         "name": title,
    //         "url": url,
    //         "description": description,
    //         "provider": {
    //             "@type": "Organization",
    //             "name": provider,
    //             "url": "https://ishantechnologies.com"
    //         },
    //         "category": parentTitle,
    //         "serviceType": "Cloud Services"
    //     }

    //     const breadcrumbSchema = {
    //         "@context": "https://schema.org",
    //         "@type": "BreadcrumbList",
    //         "itemListElement": [
    //             {
    //                 "@type": "ListItem",
    //                 "position": 1,
    //                 "name": "Home",
    //                 "item": "https://ishantechnologies.com"
    //             },
    //             {
    //                 "@type": "ListItem",
    //                 "position": 2,
    //                 "name": parentTitle,
    //                 "item": parentUrl
    //             },
    //             {
    //                 "@type": "ListItem",
    //                 "position": 3,
    //                 "name": title,
    //                 "item": url
    //             }
    //         ]
    //     }

    //     return (
    //         <>
    //             <script 
    //                 type="application/ld+json"
    //                 dangerouslySetInnerHTML={{ __html: JSON.stringify(serviceSchema) }}
    //             />
    //             <script 
    //                 type="application/ld+json"
    //                 dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
    //             />
    //         </>
    //     )
    // }
    
    // Otherwise use automatic page schema
    return <PageSchema />
}

export default SubServiceSchema